import React from 'react';
import { SendFlowContext, defaultValue, } from '../contexts/sendflow';
export const SendFlowContextProvider = ({ children }) => {
    const [state, setState] = React.useState(defaultValue);
    const value = React.useMemo(() => (Object.assign(Object.assign({}, state), { set: setState })), [state]);
    return (React.createElement(SendFlowContext.Provider, { value: value }, children));
};
